import { neutral } from "./colors";
import { primaryFont } from "./typography";

export const defaultTheme = {
  textColor: neutral[600],
  textColorInverted: neutral[100],
  primaryFont: primaryFont,
  headerBackgroundColor: neutral[500],
};
